exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".l-header[data-v-77c3c463]{position:fixed;left:0;top:0;z-index:22;width:100%;background-color:#fff}.popup[data-v-77c3c463]{width:100%;z-index:4;display:block;box-shadow:0 3px 5px rgba(0,0,0,.25);background-color:#ededed;max-height:100%;overflow-y:auto}.popupInner[data-v-77c3c463]{padding:0 40px;margin-left:auto;margin-right:auto;max-width:1130px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77c3c463","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/uikit/components/AppDefaultLayout/specialContents/authPopups/AuthPopups.vue
// module id = 850fbe63d4d2809bc78c
// module chunks = 18